import { logEvent } from "firebase/analytics";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "../config/firebase";

export const AnalyticsLogger = () => {

  const location = useLocation();

  useEffect(() => {
    if (!analytics) return;
    logEvent(analytics, "page_view", { page_path: location.pathname });
  }, [location.pathname, analytics]);

  return null
}